import React, { useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { api } from "@/redux/api";
import { useAuthEditable } from "@/hooks/use-auth";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";
import ServiceRequestDetail from "@/containers/service-request/ServiceRequestDetail";

export default function FacilityServiceRequestDetailPage() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const facilityContext = useSelector((state) => getFacilityContext(state));
  const canAddNote = useAuthEditable("serviceRequest");
  const canCreateWorkorder = useAuthEditable("workorder");
  const baseListPath = buildFacilityPath("service-request", facilityContext) || "/switch-view";
  const listPath = `${baseListPath}${location.search || ""}`;
  const loadRequest = useCallback(
    (requestId) => api.getFacilityServiceRequest(requestId),
    []
  );
  const addNote = useCallback(
    (requestId, content) => api.addFacilityServiceRequestNote(requestId, content),
    []
  );
  const quoteCost = useCallback(
    (requestId, quotedCost) => api.quoteFacilityServiceRequestCost(requestId, quotedCost),
    []
  );
  const createWorkorder = useCallback(
    (record) => {
      const createPath = buildFacilityPath("create-workorder", facilityContext);
      if (!createPath) return;
      const params = new URLSearchParams({
        source: "service-request",
        service_request_id: String(record.id),
        service_request_category_id: String(record.category),
      });
      navigate(`${createPath}?${params.toString()}`);
    },
    [facilityContext, navigate]
  );
  const getRelatedWorkorderPath = useCallback(
    (workorder) =>
      buildFacilityPath(`workorder-detail/${workorder.id}`, facilityContext) || "/switch-view",
    [facilityContext]
  );

  return (
    <ServiceRequestDetail
      requestId={id}
      listPath={listPath}
      loadRequest={loadRequest}
      addNote={addNote}
      canAddNote={canAddNote}
      canManageCost={canAddNote}
      quoteCost={quoteCost}
      canCreateWorkorder={canCreateWorkorder}
      createWorkorder={createWorkorder}
      getRelatedWorkorderPath={getRelatedWorkorderPath}
    />
  );
}
